import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { PROFILE_REPORTS_ROW_TEST_IDS } from '@/constants/data-testids';

import { TableCell, TableRow } from '../Table/Table';

export const ProfileReportsRowSkeleton = () => {
  return (
    <TableRow data-testid={PROFILE_REPORTS_ROW_TEST_IDS.SKELETON}>
      <TableCell>
        <div className="flex items-center gap-2 max-w-[220px]">
          <div>
            <Skeleton className="size-8 rounded-full" />
          </div>
          <div className="w-full flex flex-col gap-1.5">
            <Skeleton className="h-[14px] w-full" />
            <Skeleton className="h-[14px] w-2/3" />
          </div>
        </div>
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
    </TableRow>
  );
};
